import { Home } from "../components";
import { Link } from "react-router-dom";
import { LinkTextt } from "../components/home/styles/home";

export function HomeContainer({ children }) {
  return (
    <Home>
      <Home.Text>hi, im <span>Aldo</span></Home.Text>
      <Home.Text>a <span>front end web developer</span></Home.Text>
      <Home.Text>see some of my recent <span>projects</span>.</Home.Text>
      <Home.SubText>react.js | javascript | typescript | node.js</Home.SubText> 
       <Home.SubText>git | npm | jquery | php | api's | sass | tailwind | html/css</Home.SubText>
      {/* <Home.Photo src="/images/image1.jpg" /> */}
      <LinkTextt to="/work">projects</LinkTextt>
      
    </Home>
  );
}


